const trigger = (el, type) => {
    const e = document.createEvent("HTMLEvents");
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
};
/**
 * 自定义数字验证
 * 指令名称：v-Letter (默认限制输入小写字母)
 */
export default {
    bind: function(el, binding) {
        console.log("bind: ", binding);
        let params = binding.value;
        const input = el.tagName === "INPUT" ? el : el.querySelector("input");
        input.onkeyup = function(e) {
            if (params && params.isNegative && /[\-]/.test(input.value)) {
                input.value = "-" + input.value.replace(/[^a-z]/g, "");
            } else {
                input.value = input.value.replace(/[^a-z]/g, "");
            }
            trigger(input, "input");
        };
    }
};
